<div class="dialog-container" role="dialog" aria-labelledby="new-conversation-title">

  <h2 class="dialog-title" id="new-conversation-title">{{isAddMembersMode() ? 'Add Members' : 'New Conversation'}} </h2>

  <div class="search-box">
    <mat-icon> search </mat-icon>

    <input
      type="text"
      placeholder="Search users......"
      [(ngModel)]="searchQuery"
      (ngModelChange)="filterUsers()"
    />
  </div>

  <div class="users-list">
    @for (user of filteredUsers; track user.id) {
      <div
        type="button"
        class="user-item"
        [class.selected]="isSelected(user)"
        (click)="toggleUser(user)"
      >
        <div class="user-avatar">
          {{ (user.preferredName || user.first_name || '?').charAt(0) }}{{ (user.last_name || '').charAt(0) }}
        </div>

        <div class="user-details">
          <div class="user-name">
            {{ user.preferredName || user.first_name }}
            {{ user.last_name }}
          </div>
        </div>
        @if (isSelected(user)) {
          <mat-icon class="selected-icon"> check_circle </mat-icon>
        }
      </div>
    }
  </div>


  <div class="dialog-actions">
      @if(!isAddMembersMode()){
    @if (selectedUsers.length >= 2) {
      <div class="group-name-container">
        <mat-icon> groups </mat-icon>
        <input
          type="text"
          class="group-name-input"
          placeholder="Enter a group name"
          [(ngModel)]="groupName"
        />
      </div>
    }
  }

    <div class="action-buttons">
      <button mat-button (click)="dialogRef.close()">Cancel</button>

      <button
        mat-flat-button
        color="primary"
        [disabled]="selectedUsers.length === 0"
        (click)="isAddMembersMode() ? addMembers() :createConversation()"
      >
      @if (!isAddMembersMode()){
        @if (selectedUsers.length <= 1) {
          Start Chat
        } @else {
          Create Group
        }
      }
      @else {
        Add Members
      }
      </button>
    </div>
  </div>
</div>
